module.exports = __webpack_public_path__ + "assets/icons/ic_notifications-25a6.svg";